import type { depreciationMethod } from '@libs/enums';

type DepreciationMethodKey = keyof typeof depreciationMethod.enum;

const EXCLUDED_METHODS: DepreciationMethodKey[] = [
  'twoHundredDclBalMethod',
  'twoHundredFiftyDclBalMethod',
  'equalDepreciation',
  'immediateDepreciation',
  'oldDclBalMethod',
  'oldStraightLineMethod',
  'nonDepreciation',
  'straightLineMethod',
];

function getDepreciationMethodExcept(): DepreciationMethodKey[] {
  return EXCLUDED_METHODS;
}

export { getDepreciationMethodExcept };
